export enum PhotoType {
  Photo = 0,
  Logo = 1,
  Cover = 2
}
